// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2Stdr","unreadBadge":"styles_unreadBadge__1JmqG","modalContent":"styles_modalContent__piEvQ","modal":"styles_modal__26KAA"};